import { IAction, StateStatus } from 'redux/utils/common';
import * as Types from './types';
import { IFavoritesData, IClientCollectionsData } from 'services/api/client';
import * as ProductService from 'services/api/product';

export interface IState {
  favoritesData: {
    status: StateStatus | null;
    data: IFavoritesData | null;
  };
  allPropertiesCollectionData: {
    status: StateStatus | null;
    data: ProductService.IDataItems[] | null;
  };
  propertiesOneCollectionData: {
    status: StateStatus | null;
    data: any[] | null;
  };
  propertyCollectionsData: {
    status: StateStatus | null;
    data: IClientCollectionsData | null;
  };
  deleteClientCollection: {
    status: StateStatus | null;
  };
  customers: {
    data: Array<ProductService.IMiniProfile>;
    status: StateStatus | null;
  };
  shareCollection: {
    status: StateStatus | null;
  };
  removeFromFavourite: {
    status: StateStatus | null;
  };
  sendMail: {
    status: StateStatus | null;
    data: any;
  };
}

const initialState: IState = {
  favoritesData: {
    status: null,
    data: null,
  },
  allPropertiesCollectionData: {
    status: null,
    data: null,
  },
  propertiesOneCollectionData: {
    status: null,
    data: null,
  },
  propertyCollectionsData: {
    status: null,
    data: null,
  },
  deleteClientCollection: {
    status: null,
  },
  customers: {
    data: [],
    status: null,
  },
  shareCollection: {
    status: null,
  },
  removeFromFavourite: {
    status: null,
  },
  sendMail: {
    status: null,
    data: null,
  },
};

const ClientFavoritesReducer = (
  state: IState = initialState,
  action: IAction
): IState => {
  switch (action.type) {
    case Types.SET_FAVORITES:
      return {
        ...state,
        favoritesData: {
          ...state.favoritesData,
          status: action.status ?? null,
          data: action.data,
        },
      };
    case Types.SET_ALL_PROPERTIES_COLLECTION:
      return {
        ...state,
        allPropertiesCollectionData: {
          ...state.allPropertiesCollectionData,
          status: action.status ?? null,
          data: action.data,
        },
      };
    case Types.SET_PROPERTY_ONE_COLLECTION:
      return {
        ...state,
        propertiesOneCollectionData: {
          ...state.propertiesOneCollectionData,
          status: action.status ?? null,
          data: action.data,
        },
      };
    case Types.SET_PROPERTY_COLLECTIONS:
      return {
        ...state,
        propertyCollectionsData: {
          ...state.propertyCollectionsData,
          status: action.status ?? null,
          data: action.data,
        },
      };
    case Types.DELETE_ACCOUNT_COLLECTION:
      return {
        ...state,
        deleteClientCollection: {
          ...state.deleteClientCollection,
          status: action.status ?? null,
        },
      };

    case Types.SET_CUSTOMERS:
      return {
        ...state,
        customers: {
          ...state.customers,
          status: action.status || null,
          data: action.data,
        },
      };
    case Types.CLIENT_ACCOUNT_SHARE_COLLECTIONS:
      return {
        ...state,
        shareCollection: {
          ...state.shareCollection,
          status: action.status || null,
        },
      };
    case Types.SEND_EMAIL_PRODUCT:
      return {
        ...state,
        sendMail: {
          data: action.data,
          status: action.status || null,
        },
      };
    default:
      return {
        ...state,
      };
  }
};

export default ClientFavoritesReducer;
